import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Component, OnInit, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';

import { ListModel } from '../../model/list.model';
import { AuthService } from '../../service/auth.service';
import { ListValueModel } from '../../model/list-value.model';
import { AttachmentModel } from '../../model/attachment.model';
import { MessageComponent } from '../message/message.component';
import { ListValueService } from '../../service/list-value.service';
import { ReturnMessageModel } from '../../model/return-message.model';

@Component({
  selector: 'app-list-value-modal',
  templateUrl: './list-value-modal.component.html',
  styles: [`.center { align-content: center; text-align: center; }`]
})
export class ListValueModalComponent implements OnInit {
  loading = true;
  display = false;
  showId = false;
  count = 0;

  files: any;
  lastEvent: any;
	initialMidia: any;

  list: ListModel = new ListModel();
  listValues: ListValueModel[] = [];

  value: ListValueModel = new ListValueModel();

  uploadPath: string = localStorage.getItem("apiIP") + "/upload";

  // for csv export/import
  @ViewChild('fileInput') fileInput: any;
  dataToImport: any[] = [];
  status = "";

  constructor(
    private listValueService: ListValueService,
    // private listService: ListService,
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.lazy({});
  }

  lazy(e) {
    this.loading = true;
    this.lastEvent = e || {};

    const { filters, rows, first } = this.lastEvent;

    const end = rows || 50;
    const init = first || 0;
    const id = filters && filters["id"] ? filters["id"].value : null;
    const description = filters && filters["description"] ? filters["description"].value : null;
    const integration_id = filters && filters["integration_id"] ? filters["integration_id"].value : null;

    if (!this.list || !this.list.id) return console.error('No list to find');

    this.listValueService.getAll({
      integration_id: integration_id,
      list_id: this.list.id,
      init, end, id,
      description,
    }).subscribe(({ rows, count }) => {
      this.listValues = [];
      this.count = count;

      if (rows && rows.length) {
        for (const lv of rows) {
          if (lv.logo) {
            lv.url = this.getFullPath('list-value', lv.logo);
          }

          this.listValues.push(lv);
        }
      }

      this.loading = false;
    });
  }

  onShow(listId, list) {
    if (list) this.list = list;
    if(listId) {
      this.list.id = listId;
      this.lazy(this.lastEvent);
      this.display = true;
    }
  }

  onHide() {
    this.value = new ListValueModel();
    this.list = new ListModel();
    this.display = false;
  }

  onSelect(e) {
    this.value = e.data as ListValueModel;
  }

  onNew() {
    this.value = new ListValueModel();
  }

  onSave() {
    this.value.list_id = this.list.id;

    this.listValueService.save(this.value).subscribe((r: MessageComponent) => {
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  onDelete() {
    this.listValueService.delete(this.value.id).subscribe((r: ReturnMessageModel) => {
      this.lazy(this.lastEvent);
      this.onNew();
      // send success message
    });
  }

  openMenu() {
    if (this.showId && this.dataToImport && this.dataToImport.length) {
      this.listValueService.importCsv(this.dataToImport)
      .finally(() => this.dataToImport = undefined)
      .pipe(take(1)).subscribe((result: any) => {
        if (!result || result.errors && result.errors.length) {
          this.status = 'Erro ao salvar, verifique os dados';
          console.error(result);
        } else if (result.success) {
          this.status = 'Arquivo importado com sucesso!';
        }
      });
    }

    this.showId = !this.showId;
  }

  async onExportCsv() {
    const apiAddress = this.authService.getApiIP();

    // junta os filtros, e coloca todos na query do get, para criar um cache do csv
    const filtersMap = this.lastEvent.filters && Object.keys(this.lastEvent.filters).map(key => {
      const value = this.lastEvent.filters[key] && this.lastEvent.filters[key].value;
      if (value != undefined) return { [key]: value };
    }).filter(v => v) || [];
    const combinedFilters = filtersMap.reduce((acc, filter) => {
      return { ...acc, ...filter };
    }, {}) || {};

    this.listValueService.exportCsv({
        list_id: this.list.id || 0,
        count: this.count || 0,
        ...combinedFilters,
      })
      .subscribe(async (data) => {
        window.open(`${apiAddress}/upload/${data.path}`, '_blank');
      });
  }

  onImportCsv(event: Event) {
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.click(event);
    } else console.error('onImport Error');
  }

  onFileSelect(e: any) { 
    if (e.target.files && e.target.files.length) {
      const file = e.target.files[0];

      // csv validation
      if (!file.name.endsWith('.csv')) {
        this.status = 'Erro: Por favor, envie um arquivo CSV.';
        console.error(this.status);
        return;
      }

      this.status = 'Processando arquivo.';

      // convert from csv to json
      this.listValueService.importFromCsv(file, this.list.id).then((data: any[]) => {
        this.status = 'Arquivo processado com sucesso!';
        this.dataToImport = data;

        // using service to do it
        // update the fields from portugues to code
        // this.dataToImport = data.map((lv: any) => {
        //   const dto = {}; // clean object instead dto

        //   Object.keys(this.headerMap).forEach(csvKey => {
        //     const dtoKey = this.headerMap[csvKey];
        //     dto[dtoKey] = lv[csvKey] || 0;
        //   });

        //   return dto;
        // });
      }).catch(error => {
        this.status = 'Erro no processamento: ' + error;
        console.error(error);
      });
    } else {
      this.status = 'Nenhum arquivo foi selecionado';
    }
  }

	onSelectMidia(e) {
		let newFiles = [];
		if (e.files)
			Array.from(e.files).forEach((item: Blob | any, i, arr) => {
				const reader = new FileReader();

				reader.readAsDataURL(item);
				reader.onload = () => {
					newFiles.push({
						base64: reader.result,
						type: item.type.length > 0 ? item.type : item.name.split('.').pop(),
						name: item.name,
						size: item.size,
					});

					if (arr.length - 1 === i) this.files = newFiles;
					if (!this.initialMidia) this.initialMidia = this.value.logo;

					this.value.logo = this.files[0];

					return;
				};

			});
	}

	onClearMidia(e) {
		this.value.logo = this.initialMidia;
		this.files = [];
	}

  getImgContent(img): SafeUrl {
    if (!img || !img.logo || !img.logo.generated_name) return '../assets/layout/images/avatar.png';
    return this.sanitizer.bypassSecurityTrustUrl(img.logo.generated_name);
  }

  pathResolver = (attachment: AttachmentModel, fileName?: string) => 
  attachment && attachment.generated_name && attachment.generated_name.length ?
  attachment.generated_name.split('.')[0] + '/' + (fileName || attachment.generated_name) : '';

  getFullPath(folder: string, attachment: AttachmentModel) {
    let completePath = '';

    if (attachment) {
      let uploadPath = `${this.uploadPath}/${folder}-attachment/`;

      if (attachment.compressed)
      completePath = uploadPath + this.pathResolver(attachment, 'COMPRESSED.jpg');
      else
      completePath = uploadPath + this.pathResolver(attachment);

      if (attachment.generated_name && attachment.generated_name.includes('home'))
      completePath = '../assets/layout/images/preloader.gif';
    }

    return completePath;
  }

  validate(): boolean {
    return ListValueModel.validate(this.value) && !this.duplicateValidation();
  }

  duplicateValidation() {
    const exist = this.listValues && this.listValues.find(
      (list) => list.description == this.value.description
    );

    // for creation and editing
    return exist && exist.id != this.value.id;
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/list-value-modal/list-value-modal.component.ts